'use client';

import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import { Send } from "lucide-react";

export default function QuickContactSnippet() {
  const pathname = usePathname();
  const [result, setResult] = useState("");
  const [error, setError] = useState("");
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || pathname === "/contact-us") return null;

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setResult("Sending...");
    setError("");

    const form = e.currentTarget;
    const formData = new FormData(form);
    formData.append("access_key", "764428f4-acc5-4c33-9a92-8b86f8d30a64");

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });
      const data = await res.json();

      if (data.success) {
        setResult("Message sent!");
        setError("");
        form.reset();
      } else {
        setError("Something went wrong.");
        setResult("");
      }
    } catch (error) {
      setError("Something went wrong.");
      setResult("");
    }
  };

  return (
    <section className="px-4 sm:px-6 py-6 sm:pt-8">
      <div className="border max-w-6xl border-standard backdrop-blur-sm p-6 sm:p-8 mx-auto rounded-xl">
        <div className="mb-4">
          <h3 className="h3 mb-2 text-left">Quick Question?</h3>
          <p className="body-md text-left">
            Drop us a message and we'll get back to you shortly.
          </p>
        </div>

        <form onSubmit={onSubmit} className="space-y-3">
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              name="email"
              className="flex-1 px-4 py-2.5 border border-standard rounded-lg text-text-primary bg-transparent placeholder:text-text-secondary"
              placeholder="email@company.com"
              required
            />
            <input
              type="text"
              name="message"
              className="flex-1 px-4 py-2.5 border border-standard rounded-lg text-text-primary bg-transparent placeholder:text-text-secondary"
              placeholder="Your quick message..."
              required
            />
            <button
              type="submit"
              className="btn inline-flex items-center justify-center gap-2 px-5 py-2.5"
            >
              Send <Send className="w-4 h-4" />
            </button>
          </div>

          {result && (
            <p className="text-left text-accentcolourteal body-md font-semibold">{result}</p>
          )}
          {error && (
            <p className="text-left text-red-500 body-md font-semibold">{error}</p>
          )}
        </form>
      </div>
    </section>
  );
}